import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { storage } from '../firebase';

const upload = (file: File, uploadPath: string, onUploadProgress: (progress: number) => void, onUploadComplete: (downloadUrl: string) => void) => {
  const bucketPath = uploadPath + '/' + file.name;
  const storageRef = ref(storage, bucketPath);
  const uploadTask = uploadBytesResumable(storageRef, file);

  uploadTask.on('state_changed',
    (snapshot) => {
      const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
      onUploadProgress(progress);
    },
    (error) => {
      // Handle unsuccessful uploads
    },
    () => {
      // Handle successful uploads on complete
      getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
        onUploadComplete(downloadURL);
      });
    }
  );
};

const uploadUserDeck = (file: File, teamId: string, userId: string, onUploadProgress: (progress: number) => void, onUploadComplete: (downloadUrl: string) => void) => {
  return upload(file, `/decks/${teamId}/${userId}/uploads`, onUploadProgress, onUploadComplete);
};

const FileService = {
  uploadUserDeck,
};
export default FileService;
